function getSliderButtons() {
  return document.querySelectorAll(
    '[data-action="sliderNext"], [data-action="sliderPrev"]'
  );
}

function setupSliders() {
  const sliderButtons = getSliderButtons();
  let sliderPositions = {};

  sliderButtons.forEach((el) => {
    el.addEventListener('click', () => {
      const id = el.getAttribute('data-controls');
      const action = el.getAttribute('data-action');
      const slider = document.getElementById(id);
      const slides = slider.getElementsByTagName('div');
      const slidesCount = slides.length;
      // const sliderWidth = slider.getBoundingClientRect().width;
      let currentSlide = 0;

      // get all slide positions
      if (typeof sliderPositions[id] === 'undefined') {
        sliderPositions[id] = [];
        slider.querySelectorAll('.slider__item').forEach((item) => {
          sliderPositions[id].push(
            Math.round(item.getBoundingClientRect().left)
          );
        });
      }

      // compare the scroll position to the slide position
      for (let i = sliderPositions[id].length - 1; i >= 0; i--) {
        if (
          sliderPositions[id][i] >=
          parseFloat(slider.getAttribute('data-scrollLeft'))
        ) {
          currentSlide = i;
        }
      }

      // next or prev slider
      if (action === 'sliderNext') {
        currentSlide++;
        if (currentSlide >= slidesCount) {
          currentSlide = 0;
        }
      } else {
        currentSlide--;
        if (currentSlide < 0) {
          currentSlide = slidesCount - 1;
        }
      }

      // scroll to the new current slider
      const item = slider.getElementsByTagName('div')[currentSlide];
      slider.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      return false;
    });
  });

  // update the scroll position on each slider so it's easy to access
  document.querySelectorAll('.slider').forEach((el) => {
    el.setAttribute('data-scrollLeft', 0);

    el.addEventListener(
      'scroll',
      (event) => {
        el.setAttribute('data-scrollLeft', el.scrollLeft);
      },
      { passive: true }
    );
  });

  window.addEventListener('resize', function (e) {
    sliderPositions = {};
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setupSliders();
});
